import { Logo, BarsLoader } from '@insight-health-ai/roseate/components';

type AppLoaderProps = {
  loaderText?: string;
};

export const AppLoader = ({ loaderText }: AppLoaderProps) => {
  return (
    <div className="loader-wrapper flex flex-col items-center justify-center w-[100vw] h-[100vh]">
      <Logo width="190" />
      {loaderText && (
        <div className="text-red-600 font-xl flex justify-center mt-2 font-bold text-lg">
          {loaderText}
        </div>
      )}
      <BarsLoader />
    </div>
  );
};
